import { BehaviorSubject } from 'rxjs';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { Injectable } from '@angular/core';
import { PointStoreProductEditService } from './point-store-product-edit.service';

@Injectable({
  providedIn: 'root'
})
export class PointStoreCategoriesService {

  data: any = {
    categories: null,
    uniqueCategories: null,
    isLoaded: false,
    categoryMap: [], //Colton
    comboBoxCategoryMap: [], //Colton
    categoryList: [],
    isCategoriesChange: false,
  }
  pspef: any = null;
  genSubCategory = "All";

  //reset category and subcategory array on product info form
  private _resetCategory = new BehaviorSubject([]);
  resetDataCategory = this._resetCategory.asObservable();
  private _resetSubCategory = new BehaviorSubject([]);
  resetDataSubCategory = this._resetCategory.asObservable();

  //category, subcategory state
  private _filter = new BehaviorSubject({});
  category$ = this._filter.asObservable();

  constructor(
    private pointStoreProductEditService: PointStoreProductEditService,
    private cvApiService: CVApiService,
  ) {
    this.pspef = pointStoreProductEditService.pointStoreProductEditObj
  }

  async loadCategory() {
    try {
      // set setUpgLoad was removed from here to handle the loader in the front-end
      const url = "/api/v1/marketplace/categories/";
      let response: any = await this.cvApiService.get(url);
      if (response.status_code == 200) {
        return response.data;
      }
      else {
        throw response;
      }
    } catch (error) {
      showErrorMessage("Error Loading Categories: " + error.message);
    }
  }

  async loadCategoryMap(forFilter) {
    try {
      // set setUpgLoad was removed from here to handle the loader in the front-end
      const url = "/api/v1/marketplace/categories/subcategories/" + forFilter +'/';
      let response: any = await this.cvApiService.get(url);
      if (response.status_code == 200) {
        return response.data;
      }
      else {
        throw response;
      }
    } catch (error) {
      showErrorMessage("Error loading categories: " + error.message);
    }
  }

  getCategories() {
    if (!this.data.isLoaded) return;

    let categories = [];
    for (let i = 0; i < this.data.categoryMap.length; i++) {
      categories.push(this.data.categoryMap[i].Item1);
    }
    return categories;
  }

  getSubCategories(category) {
    if (!this.data.isLoaded) return;

    let subCategories = [];
    for (let i = 0; i < this.data.categoryMap.length; i++) {
      if (this.data.categoryMap[i].Item1 == category) {
        for (let j = 0; j < this.data.categoryMap[i].Item2.length; j++) {
          subCategories.push(this.data.categoryMap[i].Item2[j]);
        }
      }
    }
    return subCategories;
  }

  async loadCategories(forFilter) {
    if (this.data.isLoaded) { return null; }

    const comboLoadResult = await this.loadCategoryMap(false);
    if (comboLoadResult) {
      this.data.comboBoxCategoryMap = comboLoadResult;
      // set setUpgLoad was removed from here to handle the loader in the front-end

      const result = await this.loadCategoryMap(forFilter);
      if (result) {
        this.data.categoryMap = [];
        this.data.categoryList = [];
        this.data.isLoaded = true;
        this.data.categoryMap = result;

        this.data.categoryList = this.formatCategories(this.data.categoryMap);
        this.data.isCategoriesChange = true;
      }
    }
  }

  setUniqueCategories() {
    let newItems = [];

    angular.forEach(this.data.categories, (item) => {
      let isDuplicate = false;

      for (let i = 0; i < newItems.length; i++) {
        if (angular.equals(newItems[i].Category, item.Category)) {
          isDuplicate = true;
          break;
        }
      }
      if (!isDuplicate) {
        newItems.push(item);
      }
    });
    this.data.uniqueCategories = angular.copy(newItems);

    return newItems;
  }

  sortCategory() {
    this.data.categories.sort((a, b) => {
      if (a.Category < b.Category) return -1;
      if (a.Category > b.Category) return 1;
      return 0;
    });
  }

  /*removeCategory() { /****************
    let newObj = this.data.categories.filter((item) => {
      let match = false;

      if (item.Category == this.pointStoreProductEditSaveService.pspef.modifiedPointStoreProduct.Category) {
        match = true;
      }
      return match;
    });
    if (newObj.length == 0) {
      this.data.categories.splice(this.getIndexCategoryFromPointStoreProduct(this.pointStoreProductEditSaveService.pspef.modifiedPointStoreProduct.Category), 1);
      this.sortCategory();
    }
    this.setUniqueCategories();
  }*/

  getIndexCategoryFromPointStoreProduct(Category) {
    //var index = pointStoreCategoriesFactory.data.categories.findIndex(x => x.Category == Category);
    let index = -1;

    for (let i = 0; i < this.data.categories.length; i++) {
      if (this.data.categories[i].Item1 == Category) {
        index = i;
        break;
      }
    }
    return index;
  }

  /**
   * format categories for cxone
   * @returns categories array 
   */
  formatCategories(categoryMap): any[] {
    const categories = categoryMap.map((category, index) => ({
      id: index + 1,
      name: category.m_Item1,
      subcategories: category.m_Item2
    }));
    return categories;
  }

   /**
   * resetCategories array
   */
   resetCategoriesList() {
    this._resetCategory.next([]);
    this._resetSubCategory.next([]);
  };

  /**
   * 
   * @param filter 
   */
  saveFilterState(filter) {
    //prevent to execute if is not required
    if(!this.data.isCategoriesChange){
      return;
    }
    this._filter.next(filter);
  }
}
